const speeds = {
  "-5": 0.9,
  "-4": 0.7,
  "-3": 0.5,
  "-2": 0.3,
  "-1": 0.1,
  0: 0,
  1: -0.1,
  2: -0.3,
  3: -0.5,
  4: -0.7,
  5: -0.9
};

const parseSpeed = speed => speeds[speed.toString()] || speeds["-1"];

export default parseSpeed;